import React from 'react';
import './FilePreviewModal.css';
import {
  FaFilePdf, FaFileWord, FaFileExcel, FaFilePowerpoint,
  FaFileImage, FaFileCode, FaFileAlt
} from 'react-icons/fa';

const getFileIcon = (fileName) => {
  const ext = fileName.split('.').pop().toLowerCase();

  if (['jpg', 'jpeg', 'png', 'gif', 'webp', 'svg'].includes(ext)) return <FaFileImage color="#9ca3af" />;
  if (ext === 'pdf') return <FaFilePdf color="#e11d48" />;
  if (['doc', 'docx'].includes(ext)) return <FaFileWord color="#2563eb" />;
  if (['xls', 'xlsx', 'csv'].includes(ext)) return <FaFileExcel color="#16a34a" />;
  if (['ppt', 'pptx'].includes(ext)) return <FaFilePowerpoint color="#c026d3" />;
  if (['js', 'html', 'css', 'json', 'py'].includes(ext)) return <FaFileCode color="#4b5563" />;

  return <FaFileAlt color="#6b7280" />;
};

const FilePreviewModal = ({ isOpen, onClose, files }) => {
  if (!isOpen) return null;

  return (
    <div className="modal-overlay">
      <div className="modal-content">
        <button onClick={onClose} className="close-btn">✖</button>
        <h2 className="modal-title">📁 Related Files</h2>
        <ul className="file-list">
          {files.map((file, idx) => (
            <li key={idx} className="file-item">
              <a
                href={file.url}
                target="_blank"
                rel="noopener noreferrer"
                className="file-link"
              >
                <span style={{ display: 'inline-flex', alignItems: 'center', marginRight: '8px', verticalAlign: 'middle' }}>
                  {getFileIcon(file.name)}
                </span>
                {file.name}
              </a>
              <div className="file-meta">
                <div style={{ marginBottom: '4px' }}><strong>Uploaded:</strong> {file.uploadedAt}</div>
                <div style={{ marginBottom: '4px' }}><strong>Modified:</strong> {file.lastModified}</div>
                <div><strong>Folder:</strong> {file.folder || 'N/A'}</div>
              </div>
            </li>
          ))}
        </ul>
      </div>
    </div>
  );
};

export default FilePreviewModal;
